<template>
    <div id="contenedor-sinfraestructura-main">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'InfraestructuraMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
